import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { PoreskoOslobodjenje } from './poresko-oslobodjenje';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-poresko-oslobodjenje-modal-update',
  templateUrl: './poresko-oslobodjenje-modal-update.component.html'})
export class PoreskoOslobodjenjeModalUpdateComponent extends BaseModalUpdateComponent<PoreskoOslobodjenje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PoreskoOslobodjenje>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
